import Firm from "../../entities/firm";

/**
 * Firm actions
 *
 * Call order:
 *
 * FIRM_SAVE_QUEUE:	adds the item to the save queue
 * --> FIRM_SAVE:	modifies the state
 * --> FIRM_SAVE_SUCCESS: if all went well
 * --> FIRM_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail FIRM_SAVE_QUEUE is during the call to FIRM_SAVE,
 * as adding an item to the queue should never fail.
 */

export const FIRM_FETCH_ONE_QUEUE: any = 'FIRM_FETCH_ONE_QUEUE';
export const FIRM_FETCH_SUCCESS: any = 'FIRM_FETCH_SUCCESS';
export const FIRM_FETCH_FAILURE: any = 'FIRM_FETCH_FAILURE';
export const FIRM_FETCH_ONE_SUCCESS: any = 'FIRM_FETCH_ONE_SUCCESS';
export const FIRM_FETCH_ONE_FAILURE: any = 'FIRM_FETCH_ONE_FAILURE';

export const FIRM_SAVE: any = 'FIRM_SAVE';
export const FIRM_SAVE_QUEUE: any = 'FIRM_SAVE_QUEUE';
export const FIRM_SAVE_SUCCESS: any = 'FIRM_SAVE_SUCCESS';
export const FIRM_SAVE_FAILURE: any = 'FIRM_SAVE_FAILURE';

export const FIRM_SAVE_MANY: any = 'FIRM_SAVE_MANY';
export const FIRM_SAVE_MANY_QUEUE: any = 'FIRM_SAVE_MANY_QUEUE';
export const FIRM_SAVE_MANY_SUCCESS: any = 'FIRM_SAVE_MANY_SUCCESS';
export const FIRM_SAVE_MANY_FAILURE: any = 'FIRM_SAVE_MANY_FAILURE';

export const FIRM_REMOVE: any = 'FIRM_REMOVE';
export const FIRM_REMOVE_QUEUE: any = 'FIRM_REMOVE_QUEUE';
export const FIRM_REMOVE_SUCCESS: any = 'FIRM_REMOVE_SUCCESS';
export const FIRM_REMOVE_FAILURE: any = 'FIRM_REMOVE_FAILURE';

export const FIRM_RESTORE: any = 'FIRM_RESTORE';
export const FIRM_RESTORE_QUEUE: any = 'FIRM_RESTORE_QUEUE';
export const FIRM_RESTORE_SUCCESS: any = 'FIRM_RESTORE_SUCCESS';
export const FIRM_RESTORE_FAILURE: any = 'FIRM_RESTORE_FAILURE';

export const FIRM_RESTORE_MANY: any = 'FIRM_RESTORE_MANY';
export const FIRM_REMOVE_MANY: any = 'FIRM_REMOVE_MANY';

/* Fetch actions */
export const fetchFirmSuccess = (firms: Firm[], partial: boolean, lastFetch: number) => ({type: FIRM_FETCH_SUCCESS, firms, partial, lastFetch});
export const fetchFirmFailure = (err: any) => {
		console.error('FirmAction: fetchFirmFailure', err);
		return {type: FIRM_FETCH_FAILURE, err};
};
export const fetchOneFirmQueue = (firmId: string) => ({type: FIRM_FETCH_ONE_QUEUE, firmId});
export const fetchOneFirmSuccess = (firm: Firm) => ({type: FIRM_FETCH_ONE_SUCCESS, firm});
export const fetchOneFirmFailure = (id: string, err: any) => {
		console.error('FirmAction: fetchOneFirmFailure', err);
		return {type: FIRM_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveFirm = (firm: Firm) => {
    // console.debug('⮂ FIRM_SAVE action', firm?.id);
    return {type: FIRM_SAVE, firm};
}
export const saveFirmQueue = (firm: Firm) => {
    // console.debug('⮂ FIRM_SAVE_QUEUE action', firm?.id);
    return {type: FIRM_SAVE_QUEUE, firm};
}
export const saveFirmSuccess = (firm: Firm) => {
    // console.debug('⮂ FIRM_SAVE_SUCCESS action', firm?.id);
    return {type: FIRM_SAVE_SUCCESS, firm};
}
export const saveFirmFailure = (firm: Firm, status: number, message: string) => {
    console.warn(`⮂ FIRM_SAVE_FAILURE error saving firm: HTTP ${status}: ${message}`, firm?.id);
    return {type: FIRM_SAVE_FAILURE, firm, status, message};
};

/* SaveMany actions */
export const saveManyFirms = (firms: Firm[]) => {
    // console.debug('⮂ FIRM_SAVE_MANY action', firms?.map(firm => firm?.id).join(','));
    return {type: FIRM_SAVE_MANY, firms};
}
export const saveManyFirmsQueue = (firms: Firm[]) => {
    // console.debug('⮂ FIRM_SAVE_MANY_QUEUE action', firms?.map(firm => firm.id).join(','));
    return {type: FIRM_SAVE_MANY_QUEUE, firms};
}

export const saveManyFirmsSuccess = (firms: Firm[]) => {
    // console.debug('⮂ FIRM_SAVE_MANY_SUCCESS action', firms?.map(firm => firm.id).join(','));
    return {type: FIRM_SAVE_MANY_SUCCESS, firms};
}
export const saveManyFirmsFailure = (firms: Firm[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_FIRMS_FAILURE Error saving firms: HTTP ${status}: ${message}`, firms?.map(firm => firm.id).join(','));
		return {type: FIRM_SAVE_MANY_FAILURE, firms, status, message};
};

/* Remove actions */
export const removeFirm = (firm: Firm) => ({ type: FIRM_REMOVE, firm });
export const removeFirmQueue = (firm: Firm) => ({ type: FIRM_REMOVE_QUEUE, firm });
export const removeFirmSuccess = (firm: Firm) => ({ type: FIRM_REMOVE_SUCCESS, firm });
export const removeFirmFailure = (firm: Firm, status: number, message: string) => {
	console.error(`Redux: removeFirmFailure Error removing firm: HTTP ${status}: ${message}`);
	return ({ type: FIRM_REMOVE_FAILURE, firm, status, message });
};

/* Restore actions */
export const restoreFirm = (firm: Firm) => ({ type: FIRM_RESTORE, firm });
export const restoreFirmQueue = (firm: Firm) => ({ type: FIRM_RESTORE_QUEUE, firm });
export const restoreFirmSuccess = (firm: Firm) => ({ type: FIRM_RESTORE_SUCCESS, firm });
export const restoreFirmFailure = (firm: Firm, status: number, message: string) => {
	console.error(`Redux: restoreFirmFailure Error restoring firm: HTTP ${status}: ${message}`);
	return ({ type: FIRM_RESTORE_FAILURE, firm, status, message });
};

/* RestoreMany actions */
export const restoreManyFirms = (firms: Firm[]) => ({ type: FIRM_RESTORE_MANY, firms });

/* RemoveMany actions */
export const removeManyFirms = (firms: Firm[]) => ({ type: FIRM_REMOVE_MANY, firms });